// redux/slices/propertySlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { frontPropertyList } from "../../../Services/BON-Frontend/Service";

export const getPropertyList = createAsyncThunk(
  "property/getPropertyList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await frontPropertyList();
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const propertyListSlice = createSlice({
  name: "property",
  initialState: {
    properties: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPropertyList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPropertyList.fulfilled, (state, action) => {
        state.loading = false;
        state.properties = action.payload;
      })
      .addCase(getPropertyList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default propertyListSlice.reducer;